import { useEffect, useMemo } from 'react';
import { useAppDispatch } from '../../app/hooks';
import FormulaMate from './FormulaMate';
import type { FormulaMateService } from './formulaMate.types';
import { FormulaMateRequestError } from './formulaMateService';
import { useFormulaMate } from './FormulaMateContext';
// import { FORMULA_MATE_SESSION_ID } from './formulaMate.constants';
import { resetFormulaApi } from './store/formulaApi.slice';
import {
  createFormulaSession,
  deleteFormulaSession,
  generateFormula,
  reviewFormula,
} from './store/formulaApi.thunk';

async function unwrapRequest<T>(request: Promise<T>): Promise<T> {
  try {
    return await request;
  } catch (error) {
    if (typeof error === 'string') throw new FormulaMateRequestError(error);
    throw error;
  }
}

export default function ConnectedFormulaMate() {
  const { buildFormulaActive } = useFormulaMate();
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(resetFormulaApi());
    },
    [dispatch]
  );

  const service = useMemo<FormulaMateService>(
    () => ({
      createSession: signal =>
        unwrapRequest(
          dispatch(createFormulaSession(undefined, { signal })).unwrap()
        ),
      generateFormula: (id, prompt, signal) =>
        unwrapRequest(
          dispatch(
            generateFormula({ sessionId: id, prompt }, { signal })
          ).unwrap()
        ),
      reviewCode: (id, code, _instructions, signal) =>
        unwrapRequest(
          dispatch(reviewFormula({ sessionId: id, code }, { signal })).unwrap()
        ),
      endSession: (id, signal) => {
        dispatch(resetFormulaApi());
        return unwrapRequest(
          dispatch(deleteFormulaSession(id, { signal })).unwrap()
        );
      },
    }),
    [dispatch]
  );

  return <FormulaMate service={service} visible={buildFormulaActive} />;
}
